import { get } from './utils';

export const getPermissionsApi = () => get('/admin/permissions?limit=100');
